import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your language JSON files
import en from './en.json';
import fr from './fr.json';

// Import permission module translations
import permissionEn from '../../admin/modules/GestionUtilisateurs/Permission/i18n/en.json';
import permissionFr from '../../admin/modules/GestionUtilisateurs/Permission/i18n/fr.json';

// Import AccessControl module translations
import accessControlEn from '../../admin/modules/AccessControl/i18n/en.json';
import accessControlFr from '../../admin/modules/AccessControl/i18n/fr.json';

// Import Cyberesa module translations
import cyberesaEn from '../../connectivite/cyberesa/i18n/en.json';
import cyberesaFr from '../../connectivite/cyberesa/i18n/fr.json';

// Import Travelgate v2 module translations
import travelgateV2En from '../../connectivite/travelgate/i18n/en.json';
import travelgateV2Fr from '../../connectivite/travelgate/i18n/fr.json';

// Import Moteur Reservation module translations
import moteurReservationEn from '../../admin/modules/GestionHotel/MoteurReservation/i18n/en.json';
import moteurReservationFr from '../../admin/modules/GestionHotel/MoteurReservation/i18n/fr.json';

// Import Source Production module translations
import sourceProductionEn from '../../admin/modules/GestionHotel/SourceProduction/i18n/en.json';
import sourceProductionFr from '../../admin/modules/GestionHotel/SourceProduction/i18n/fr.json';

// Import Support Tickets module translations
import supportTicketsEn from '../../admin/modules/SupportTickets/i18n/en.json';
import supportTicketsFr from '../../admin/modules/SupportTickets/i18n/fr.json';

// Import PDF Extraction Wizard translations
import pdfExtractionEn from '../../admin/modules/GestionHotel/Contrat/components/PdfExtractionWizard/i18n/en.json';
import pdfExtractionFr from '../../admin/modules/GestionHotel/Contrat/components/PdfExtractionWizard/i18n/fr.json';

// Import Dashboard module translations
import dashboardEn from '../../admin/modules/Dashboard/i18n/en.json';
import dashboardFr from '../../admin/modules/Dashboard/i18n/fr.json';

// Import Action Commerciale module translations
import actionCommercialeEn from '../../admin/modules/GestionHotel/Contrat/actionCommerciale/i18n/en.json';
import actionCommercialeFr from '../../admin/modules/GestionHotel/Contrat/actionCommerciale/i18n/fr.json';

// Import Cartes Accès & Bien-être module translations
import cartesAccesEn from '../../admin/modules/GestionCartesAccesEtBienEtre/i18n/en.json';
import cartesAccesFr from '../../admin/modules/GestionCartesAccesEtBienEtre/i18n/fr.json';

// Import Circuits module translations
import circuitsEn from '../../admin/modules/GestionCircuits/i18n/en.json';
import circuitsFr from '../../admin/modules/GestionCircuits/i18n/fr.json';

// Import Gestion Transferts module translations
import transfertsEn from '../../admin/modules/GestionTransferts/i18n/en.json';
import transfertsFr from '../../admin/modules/GestionTransferts/i18n/fr.json';

// Import External API Users module translations
import externalApiUsersEn from '../../externalApiUsers/i18n/en.json';
import externalApiUsersFr from '../../externalApiUsers/i18n/fr.json';
import exportTemplatesEn from '../../admin/modules/ExportTemplates/i18n/en.json';
import exportTemplatesFr from '../../admin/modules/ExportTemplates/i18n/fr.json';
import contratEn from '../../admin/modules/GestionHotel/Contrat/i18n/en.json';
import contratFr from '../../admin/modules/GestionHotel/Contrat/i18n/fr.json';
import octasoftEn from '../../connectivite/octasoft/i18n/en.json';
import octasoftFr from '../../connectivite/octasoft/i18n/fr.json';
import trendConnectEn from '../../connectivite/trend/i18n/en.json';
import trendConnectFr from '../../connectivite/trend/i18n/fr.json';
import amicalesEn from '../../amicales/i18n/en.json';
import amicalesFr from '../../amicales/i18n/fr.json';
import auditLogsEn from '../../admin/modules/AuditLogs/i18n/en.json';
import auditLogsFr from '../../admin/modules/AuditLogs/i18n/fr.json';
import comptabiliteEn from '../../admin/modules/Comptabilite/i18n/en.json';
import comptabiliteFr from '../../admin/modules/Comptabilite/i18n/fr.json';
import volsEn from '../../admin/modules/GestionVols/i18n/en.json';
import volsFr from '../../admin/modules/GestionVols/i18n/fr.json';
import parametresEntrepriseEn from '../../admin/modules/ParametresEntreprise/i18n/en.json';
import parametresEntrepriseFr from '../../admin/modules/ParametresEntreprise/i18n/fr.json';
import clientsVenteEn from '../../admin/modules/ConfigurationGenerale/ClientsVente/i18n/en.json';
import clientsVenteFr from '../../admin/modules/ConfigurationGenerale/ClientsVente/i18n/fr.json';
import margeGlobalEn from '../../admin/modules/MargeGlobal/i18n/en.json';
import margeGlobalFr from '../../admin/modules/MargeGlobal/i18n/fr.json';
import chambresEn from '../../admin/modules/GestionHotel/ListeChambres/i18n/en.json';
import chambresFr from '../../admin/modules/GestionHotel/ListeChambres/i18n/fr.json';
import configurationHotelEn from '../../admin/modules/GestionHotel/ConfigurationHotel/i18n/en.json';
import configurationHotelFr from '../../admin/modules/GestionHotel/ConfigurationHotel/i18n/fr.json';
import reservationsHotelEn from '../../admin/modules/GestionHotel/GestionHotel/i18n/en.json';
import reservationsHotelFr from '../../admin/modules/GestionHotel/GestionHotel/i18n/fr.json';
import listeHotelsEn from '../../admin/modules/GestionHotel/ListeHotels/i18n/en.json';
import listeHotelsFr from '../../admin/modules/GestionHotel/ListeHotels/i18n/fr.json';
import contractAuditLogsEn from '../../admin/modules/ContractAuditLogs/i18n/en.json';
import contractAuditLogsFr from '../../admin/modules/ContractAuditLogs/i18n/fr.json';
import reservationProcessLogsEn from '../../admin/modules/ReservationProcessLogs/i18n/en.json';
import reservationProcessLogsFr from '../../admin/modules/ReservationProcessLogs/i18n/fr.json';
import unconfiguredEntitiesEn from '../../admin/modules/UnconfiguredEntities/i18n/en.json';
import unconfiguredEntitiesFr from '../../admin/modules/UnconfiguredEntities/i18n/fr.json';
import sharedComponentsEn from '../components/i18n/en.json';
import sharedComponentsFr from '../components/i18n/fr.json';
import businessTargetsEn from '../../admin/components/BusinessTargetSelector/i18n/en.json';
import businessTargetsFr from '../../admin/components/BusinessTargetSelector/i18n/fr.json';

// Combine main app translations with module translations
const combinedEn = {
  ...en,
  permissions: permissionEn,
  accessControl: accessControlEn,
  cyberesa: cyberesaEn,
  travelgateV2: travelgateV2En,
  sourceProduction: sourceProductionEn,
  supportTickets: supportTicketsEn,
  pdfExtraction: pdfExtractionEn,
  dashboard: {
    ...(en.dashboard || {}),
    ...dashboardEn,
  },
  actionCommerciale: actionCommercialeEn,
  cartesAcces: cartesAccesEn,
  circuits: circuitsEn,
  transferts: transfertsEn,
  externalApiUsers: externalApiUsersEn,
  exportTemplates: exportTemplatesEn,
  contrat: contratEn,
  octasoft: octasoftEn,
  trendConnect: trendConnectEn,
  amicales: amicalesEn,
  auditLogs: auditLogsEn,
  comptabilite: comptabiliteEn,
  vols: volsEn,
  parametresEntreprise: parametresEntrepriseEn,
  clientsVente: clientsVenteEn,
  margeGlobal: margeGlobalEn,
  chambres: chambresEn,
  configurationHotel: configurationHotelEn,
  reservationsHotel: reservationsHotelEn,
  listeHotels: listeHotelsEn,
  contractAuditLogs: contractAuditLogsEn,
  reservationProcessLogs: reservationProcessLogsEn,
  unconfiguredEntities: unconfiguredEntitiesEn,
  sharedComponents: sharedComponentsEn,
  businessTargets: businessTargetsEn,
  moteurReservation: {
    ...(en.moteurReservation || {}),
    ...moteurReservationEn,
    hotelCard: {
      ...(en.moteurReservation?.hotelCard || {}),
      ...(moteurReservationEn?.hotelCard || {}),
    },
  },
};

const combinedFr = {
  ...fr,
  permissions: permissionFr,
  accessControl: accessControlFr,
  cyberesa: cyberesaFr,
  travelgateV2: travelgateV2Fr,
  sourceProduction: sourceProductionFr,
  supportTickets: supportTicketsFr,
  pdfExtraction: pdfExtractionFr,
  dashboard: {
    ...(fr.dashboard || {}),
    ...dashboardFr,
  },
  actionCommerciale: actionCommercialeFr,
  cartesAcces: cartesAccesFr,
  circuits: circuitsFr,
  transferts: transfertsFr,
  externalApiUsers: externalApiUsersFr,
  exportTemplates: exportTemplatesFr,
  contrat: contratFr,
  octasoft: octasoftFr,
  trendConnect: trendConnectFr,
  amicales: amicalesFr,
  auditLogs: auditLogsFr,
  comptabilite: comptabiliteFr,
  vols: volsFr,
  parametresEntreprise: parametresEntrepriseFr,
  clientsVente: clientsVenteFr,
  margeGlobal: margeGlobalFr,
  chambres: chambresFr,
  configurationHotel: configurationHotelFr,
  reservationsHotel: reservationsHotelFr,
  listeHotels: listeHotelsFr,
  contractAuditLogs: contractAuditLogsFr,
  reservationProcessLogs: reservationProcessLogsFr,
  unconfiguredEntities: unconfiguredEntitiesFr,
  sharedComponents: sharedComponentsFr,
  businessTargets: businessTargetsFr,
  moteurReservation: {
    ...(fr.moteurReservation || {}),
    ...moteurReservationFr,
    hotelCard: {
      ...(fr.moteurReservation?.hotelCard || {}),
      ...(moteurReservationFr?.hotelCard || {}),
    },
  },
};

const resources = {
  en: { translation: combinedEn },
  fr: { translation: combinedFr },
};

// Initialize i18n synchronously
const initPromise = i18n.use(initReactI18next).init({
  resources,
  lng: 'fr', // default language
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
  debug: false, // Disable debug mode to reduce noise
  initImmediate: true, // Initialize immediately
});

// Test translations after initialization
initPromise
  .then(() => {
    console.log('🔍 i18n fully initialized. Testing menu translations:');
  })
  .catch(error => {
    console.error('❌ i18n initialization failed:', error);
  });

export default i18n;
